import mutations from './mutations';

const BaseData = {
    namespaced: true,
    state: {
        app_name: 'LANTAS EGO-DM',
        company_name: 'RSUD Dr. Soeroto Ngawi',
        moto : '',
        visi : [
            ''
        ],
        misi : [
            ''
            
        ],
        address: '',
        description: '',
        email: '',
        phone: '',
        fax: '--',

        sosmed : [
           
            
        ],
        main_icon: '',
        second_icon: 'https://rsudgeneng.ngawikab.go.id/wp-content/uploads/2024/08/cropped-Logo-Landscape-RSUD-Geneng-Motto-Blenda-300x122.png',
        img_background: '',
        main_theme_color: '#05940C',
        second_theme_color: '#424237',
        version: '1.0.0',
    },
    mutations
};

export default BaseData;
